/*
 * QR Entry/Exit is gated on the standard per-facility feature system, exactly
 * like the API gates pass generation and gate scans: the feature is ON for a
 * hotel only while a feature_facility_provider_configuration row exists for it.
 * Admin's ON/OFF switch removes that row when turned OFF, so the presence of
 * the record is the flag — there is no configuration payload to read.
 *
 * The provider is checked alongside the feature name so this matches the API
 * and edge checks exactly — a row enabled against a different provider is not
 * our QR feature and must not light the menu up.
 */
export const QR_ENTRY_EXIT_FEATURE = "QR Entry / Exit";
export const QR_PROVIDER = "Drivo";

export function isQrEntryExitEnabled(facility) {
  return Boolean(
    facility?.featureFacilityProviderConfigurations?.some(
      (item) =>
        item?.feature?.name === QR_ENTRY_EXIT_FEATURE &&
        item?.provider?.name === QR_PROVIDER,
    ),
  );
}
